import { useCompanyFspVM } from "presentation/hook/Company/useCompanyFspVM";
import { useCompanyDetailTracked } from "presentation/store/Company/CompanyDetailProvider";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";

export const GracePeriodAccordion = () => {
    const [CompanyDtlState] = useCompanyDetailTracked();
    const { graceCountHourFrom, graceCountMinFrom, graceCountHourTo, graceCountMinTo } = CompanyDtlState.companyFspState;
    const companyFSPVM = useCompanyFspVM();
    return (
        <>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item'>
                    <NumberInputComponent
                        label={`Grace Hour Count From`}
                        width='14vw'
                        fieldName={"graceCountHourFrom"}
                        value={graceCountHourFrom || ''}
                        disabled={false}
                        maxLength={2}
                        decimalPlaces={0}
                        errorMessage={CompanyDtlState.allFormState?.graceCountHourFrom}
                        onChange={(e: any) => companyFSPVM.onBulkEditFieldChange('graceCountHourFrom', e?.target.value)}
                    />
                </div>
            </div>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item'>
                    <NumberInputComponent
                        label={`Grace Hour Count To`}
                        width='14vw'
                        fieldName={"graceCountHourTo"}
                        value={graceCountHourTo || ''}
                        disabled={false}
                        maxLength={2}
                        decimalPlaces={0}
                        errorMessage={CompanyDtlState.allFormState?.graceCountHourTo}
                        onChange={(e: any) => companyFSPVM.onBulkEditFieldChange('graceCountHourTo', e?.target.value)}
                    />
                </div>

            </div>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item'>
                    <NumberInputComponent
                        label={`Grace Minute Count From`}
                        width='14vw'
                        fieldName={"graceCountMinFrom"}
                        value={graceCountMinFrom || ''}
                        disabled={false}
                        maxLength={2}
                        decimalPlaces={0}
                        errorMessage={CompanyDtlState.allFormState?.graceCountMinFrom}
                        onChange={(e: any) => companyFSPVM.onBulkEditFieldChange('graceCountMinFrom', e?.target.value)}
                    />
                </div>
            </div>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item'>
                    <NumberInputComponent
                        label={`Grace Minute Count To`}
                        width='14vw'
                        fieldName={"graceCountMinTo"}
                        value={graceCountMinTo || ''}
                        disabled={false}
                        maxLength={2}
                        decimalPlaces={0}
                        errorMessage={CompanyDtlState.allFormState?.graceCountMinTo}
                        onChange={(e: any) => companyFSPVM.onBulkEditFieldChange('graceCountMinTo', e?.target.value)}
                    />
                </div>
            </div>
            {CompanyDtlState.forceRefresh && <></>}
        </>
    )
}